// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Undo = ({ size, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width={size}
      height={size}
      fill='none'
      stroke={stroke}
      strokeWidth='2px'
    >
      <path
        xmlns='http://www.w3.org/2000/svg'
        d='M12,20.5c-1,0-2-.2-3-.5-1.7-.6-3.2-1.8-4.1-3.3l.8-.5c.9,1.3,2.2,2.4,3.7,2.9,1.5.6,3.2.6,4.7.2,1.6-.4,2.9-1.4,3.9-2.6,1-1.3,1.5-2.8,1.6-4.4,0-1.6-.4-3.2-1.4-4.5-.9-1.3-2.3-2.3-3.8-2.8-1.5-.5-3.2-.5-4.7,0-1.5.5-2.7,1.4-3.7,2.6h4v1h-5.5V3h1v3.5c1-1.2,2.3-2.1,3.9-2.6,1.7-.6,3.6-.6,5.3,0,1.7.6,3.2,1.7,4.3,3.2,1.1,1.5,1.6,3.3,1.6,5.1,0,1.8-.7,3.6-1.8,5-1.1,1.4-2.6,2.5-4.4,3-.8.2-1.5.3-2.3.3ZM5.5,7.5h.2-.2c0-.1,0,0,0,0Z'
      />
    </svg>
  );
};
